export default "__VITE_ASSET__CBKBCF84__"